var moment = require('moment');

module.exports = {
    zeroPad: function (n, width, z) {
        "use strict";
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },
    twentyPrepend: function (n) {
        "use strict";
        if (n.length === 2) {
            return '20' + n;
        }

        return n;
    },
    removeErrorMessages: function () {
        "use strict";
        $('.date-day').removeClass('parsley-error');
        $('.date-month').removeClass('parsley-error');
        $('.date-year').removeClass('parsley-error');
    },

    addErrorMessages: function () {
        "use strict";
        $('.date-day').addClass('parsley-error');
        $('.date-month').addClass('parsley-error');
        $('.date-year').addClass('parsley-error');
    },

    isInteger: function (number) {
        "use strict";
        if (number === null || number === "") {
            return false;
        }
        return number % 1 === 0;
    },
    
    today: function today() {
        return moment(new Date());
    },
    
    stripSpaces: function stripSpaces(textWithSpaces) {
        return textWithSpaces.replace(/ /g,'');
    }
};
